import React, { useContext } from 'react';
import { Container } from '@mui/material';
import ResponsiveAppBar from '../layout/ResponsiveAppBar';
import TopMenu from '../layout/TopMenu';
import Footer from '../layout/Footer';
import AccountContext from '../context/AccountContext';
import { AccountType } from '../enum/AccountType';
import AccountTypeForm from '../components/Profile/AccountTypeForm';
import PersonProfileForm from '../components/Profile/Person/PersonProfileForm';
import MfLinearSimpleProgress from '../components/UI/Progress/MfLinearSimpleProgress';
import IpProfileForm from '../components/Profile/IP/IpProfileForm';
import LegalProfileForm from '../components/Profile/Legal/LegalProfileForm';
import SessionList from '../components/Session';

const ProfilePage = () => {
  const { accountResponse } = useContext(AccountContext);

  return (
    <>
      <ResponsiveAppBar />
      <TopMenu />
      <Container maxWidth="xl">
        {!accountResponse && <MfLinearSimpleProgress />}
        {Boolean(accountResponse) && (
          <>
            {!accountResponse?.type && <AccountTypeForm />}
            {accountResponse?.type === AccountType.PERSON && (
              <PersonProfileForm />
            )}
            {accountResponse?.type === AccountType.IP && <IpProfileForm />}
            {accountResponse?.type === AccountType.LEGAL && (
              <LegalProfileForm />
            )}
            <div>
              <h2>Активные сессии</h2>
              <SessionList />
            </div>
          </>
        )}
      </Container>
      <Footer />
    </>
  );
};

export default ProfilePage;
